import { useEffect } from "react";

import { ActivityType } from "__graphql__/types";
import { usePublishActivityStatusChanged } from "flows/Activities/hooks/usePublishActivityStatusChanged";

/**
 * Fires `publishActivityStatusStart` when `active` flips to `true` and
 * `publishActivityStatusEnd` when it flips back to `false` (or on unmount).
 *
 * Use this instead of `ActivityRouteTracker` when the tracker needs to live
 * inside a component whose JSX shape changes across renders — e.g. when the
 * tree position of `<Outlet />` is conditional. The hook is tied to the
 * component instance, not a JSX position, so re-renders don't trigger
 * spurious START/END events.
 */
export function useActivityRouteTracker(activityType: ActivityType, active: boolean) {
  const { publishActivityStatusStart, publishActivityStatusEnd } =
    usePublishActivityStatusChanged(activityType);

  useEffect(() => {
    if (!active) return;
    publishActivityStatusStart();
    return () => {
      publishActivityStatusEnd();
    };
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);
}
